// extracted by mini-css-extract-plugin
export var bigTitle = "iconModule-module--bigTitle--qiNF6";
export var decoration = "iconModule-module--decoration--tgFRY";
export var description = "iconModule-module--description--Xz5Rn";
export var findOutMore = "iconModule-module--findOutMore--aX7T4";
export var gradient = "iconModule-module--gradient--qSUMg";
export var iconElement = "iconModule-module--iconElement--epMmy";
export var icons = "iconModule-module--icons--KGd3m";
export var pureImage = "iconModule-module--pureImage--8nvAx";
export var row = "iconModule-module--row--xhk5J";
export var sbShowMain = "iconModule-module--sb-show-main---HZJA";
export var storybook = "iconModule-module--storybook--hQdfA";
export var subtitle = "iconModule-module--subtitle--XHjbJ";
export var title = "iconModule-module--title--IxwkH";
export var totaraBackground = "iconModule-module--totaraBackground--RtbQ3";
export var twoRows = "iconModule-module--twoRows--L6CR8";
export var wrapper = "iconModule-module--wrapper--o0Lo0";